import React from "react";

export const VrindaLogo = ({ className = "", markOnly = false }) => {
  return (
    <div className={`flex items-center gap-3 ${className}`.trim()}>
      <div className="relative h-10 w-10 shrink-0">
        <div className="absolute inset-0 rounded-xl bg-gradient-to-b from-[#f4ede1] to-[#e8dcc9] shadow-[0_10px_30px_rgba(16,24,40,0.18)]" />
        <div className="absolute inset-[1px] rounded-[11px] bg-white/40 backdrop-blur-xl" />
        <svg
          className="absolute left-1/2 top-1/2 h-8 w-8 -translate-x-1/2 -translate-y-1/2"
          viewBox="0 0 64 64"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          aria-hidden="true"
        >
          {/* Mor pankhi (peacock feather) – simplified mark */}
          <path
            d="M46.8 13.2c-8.5 1.2-16 7.1-20.4 15.9-3.4 6.7-4.1 14.2-2.2 20.8 3.8-8.8 9.7-17.2 18.8-22.4 4.2-2.4 8.6-3.8 13.3-4.2-2.6-4.9-6-8.4-9.5-10.1Z"
            fill="#0F766E"
            opacity="0.9"
          />
          <path
            d="M44.9 16.7c-7 1.7-13.1 6.7-16.6 13.9-2.6 5.3-3.3 11.1-2.4 16.6 3.6-7.4 9.2-14.1 17.4-18 3.2-1.6 6.6-2.6 10.2-3.1-2-3.7-4.8-6.7-8.6-9.4Z"
            fill="#065F46"
            opacity="0.55"
          />
          <path
            d="M24.2 49.6c6.2-10.3 14.4-18.3 26.4-21.9"
            stroke="#0B1220"
            strokeWidth="2.6"
            strokeLinecap="round"
            opacity="0.7"
          />
          <circle cx="46" cy="22" r="3.2" fill="#D4A72C" opacity="0.95" />
          <circle cx="46" cy="22" r="1.6" fill="#0B1220" opacity="0.75" />
        </svg>
      </div>

      {!markOnly && (
        <div className="leading-tight">
          <div className="text-[15px] font-semibold tracking-tight text-slate-900">
            <span className="relative">
              Vrinda
              <span className="pointer-events-none absolute -bottom-2 left-0 right-0 h-3 bg-[radial-gradient(closest-side,rgba(15,118,110,0.18),transparent)]" />
            </span>{" "}
            <span className="text-slate-700">Homes</span>
          </div>
          <div className="text-[12px] text-slate-600">Real Estate • Gurgaon</div>
        </div>
      )}
    </div>
  );
};
